import React from 'react';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// MAIN COMPONENT
const MultiValueRemove = ({ innerProps, ...props }) => (
  <components.MultiValueRemove
    innerProps={Object.assign({}, innerProps, {
      onClick: e => {
        const { name, formikBag: { setFieldTouched } } = props.selectProps;
        doCallback(setFieldTouched, name);
        doCallback(innerProps.onClick, e);
      }
    })}
    {...props}
  />
)

// EXPORT
export default MultiValueRemove
